import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Countdown extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      startTime: props.time || 0,
      time: props.time || 0,
    };
  }
  componentWillUnmount() {
    this.clearTimer();
  }
  stopTimer() {
    if (this.props.onComplete) {
      this.props.onComplete();
    }
  }
  startTimer(newTime) {
    this.clearTimer(); // clear previous timer
    if (this.props.onStart) {
      this.props.onStart();
    }
    if (newTime) {
      this.setState({ startTime: newTime, time: newTime }, () => {
        this.timerStart();
      });
    } else {
      this.timerStart();
    }
  }
  timerStart = () => {
    this.timer = setInterval(() => {
      const { time } = this.state;
      if (time <= 0) {
        this.clearTimer();
        this.stopTimer();
      } else {
        this.setState({ time: time - 1 });
      }
    }, 1000);
  }
  clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
  render() {
    return (
      <span className="countdown">
        {
          this.props.message ?
            this.props.message(this.state.time, this.state.startTime) :
            this.state.time
        }
      </span>
    );
  }
}

Countdown.propTypes = {
  time: PropTypes.number,
  onStart: PropTypes.func,
  onComplete: PropTypes.func,
  message: PropTypes.func,
};

export default Countdown;



// WEBPACK FOOTER //
// ./src/components/Countdown.jsx